import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-opporunities-page',
  template: `
  <div class="intercom-container-op">
    <router-outlet></router-outlet>
  </div>
  `
})
export class OpporunitiesPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
